import { configureStore } from "@reduxjs/toolkit";
import clickssReducer from "./features/clicksSlice";

import authReducer from "./features/authSlice";

const store = configureStore({
  reducer: {
    authReducer: authReducer,
    clicks: clickssReducer,
    userAuth: authReducer,
  },
});

export default store;
